// extracted by mini-css-extract-plugin
export default {"pin":"Pin_pin__54UmB"};